import { Button, IconButton } from '@ads/components-react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import * as Dialog from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';

export interface UnsavedChangesModalProps {
  readonly open: boolean;
  /** Confirma saída descartando as alterações */
  readonly onLeave: () => void;
  /** Cancela e mantém o usuário na página */
  readonly onCancel: () => void;
}

/**
 * Modal de confirmação exibido quando o usuário tenta sair do formulário
 * com alterações não salvas.
 */
export function UnsavedChangesModal({ open, onLeave, onCancel }: UnsavedChangesModalProps) {
  const { t } = useTranslation('personManagement');

  return (
    <Dialog.Root open={open} onOpenChange={o => !o && onCancel()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-none z-50 h-screen w-screen bg-base-gray-900 bg-opacity-medium backdrop-blur-soft" />

        <Dialog.Content
          className="fixed left-1/2 top-1/2 z-50 flex max-h-[85vh] w-full max-w-md -translate-x-1/2 -translate-y-1/2 flex-col rounded-md bg-ctx-layout-surface shadow-level3 focus:outline-none"
          aria-describedby={undefined}
        >
          {/* Header */}
          <div className="flex items-center justify-between border-b-hairline border-ctx-layout-border px-xs py-mini">
            <Dialog.Title className="ts-heading-sm text-ctx-content-title">
              {t('personForm.unsavedModal.title')}
            </Dialog.Title>
            <Dialog.Close asChild>
              <IconButton
                icon={XMarkIcon}
                hierarchy="tertiary"
                size="sm"
                ariaLabel={t('personForm.unsavedModal.cancel')}
              />
            </Dialog.Close>
          </div>

          {/* Body */}
          <div className="px-xs py-mini">
            <p className="ts-paragraph-xs text-ctx-content-base">
              {t('personForm.unsavedModal.body')}
            </p>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-xs border-t-hairline border-ctx-layout-border px-xs py-mini">
            <Button hierarchy="secondary" size="lg" onClick={onCancel}>
              {t('personForm.unsavedModal.cancel')}
            </Button>
            <Button hierarchy="danger" size="lg" onClick={onLeave}>
              {t('personForm.unsavedModal.confirm')}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
